import React from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '@material-ui/core/Button';

import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';

import './index.css';

const translate = (key: string) => {
  if (key === 'home.logout') {
      return 'Logout';
  }
  return key;
}


const MainPage = () => {

  const navigate = useNavigate();


  const submitLogout = async () => {
    try {
      localStorage.setItem('OrgId', '');
      localStorage.setItem('token', '');
      navigate(`/`);
    } catch (err) {
      throw Error('Unable to submit logout');
    }
  };

  return (
    <div className="wrapper">
      <div className="header">
        <div className="header-content">
          <a href="/" className="header-link">
            <h1 className="header-title">Tom Kean Jr. and the Healthcare Crisis</h1>
          </a>
          <Button onClick={() => submitLogout()} className="logout-button">
          {translate('home.logout')}
          </Button>
        </div>
      </div>
      <div className="body">
        <div className="contentWrapper">
          <div className="content">
          <Tabs className="tabs-wrapper" defaultValue={0}>
            <TabList className="tablist">
              <Tab className="tablist">Tasks</Tab>
              <Tab className="tablist">Prompts</Tab>
              <Tab className="tablist">Filters</Tab>
              <Tab className="tablist">ApiKeys</Tab>
            </TabList>
            <TabPanel className="tablist" value={0}>

            </TabPanel>
          </Tabs>
          </div>
        </div>
        <div className="footer">
          <div className="footer-disclaimer">
            <span> Fighting for Healthcare, Fighting for You.</span>
          </div>
          <div className="footer-links">
            <a href={process.env.PUBLIC_URL + '/privacy-policy.html'}
              className="footerLink"
              target="_blank"
              rel="noreferrer">
              <span>Privacy</span>
            </a>

            <a href={process.env.PUBLIC_URL + '/terms-of-use.html'}
            className="footerLink"
            target="_blank"
            rel="noreferrer">
              <span>Terms</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainPage;
